import React, {Component} from 'react';

export class HelpfulInformationListItem extends Component {
  static propTypes = {
    helpfulInformation: React.PropTypes.object.isRequired,
  };

  render() {
    const {header, title, path, image} = this.props.helpfulInformation;

    return (
      <li className="helpful-information-list">
        <a
          className="helpful-information-list__link"
          href={path}
          target="_blank"
        >
          <img
            className="helpful-information-list__image"
            src={image}
            alt={`${title}-image`}
          />
          <header className="helpful-information-list__title">{header}</header>
        </a>
      </li>
    );
  }
}

export default HelpfulInformationListItem;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/HelpfulInformation/HelpfulInformationListItem.js